<template>
  <div class="step-resumo">
    <!-- Informações -->
    <div class="step-resumo__section">
      <div class="section-label">Informações</div>
      <div class="step-resumo__grid">
        <div class="step-resumo__field">
          <span class="step-resumo__field-label">Descrição</span>
          <span class="step-resumo__field-value">
            {{ item.descricao || "—" }}
          </span>
        </div>
        <div class="step-resumo__field">
          <span class="step-resumo__field-label">Período</span>
          <span class="step-resumo__field-value">
            {{ item.dataInicio | date }} — {{ item.dataFim | date }}
          </span>
        </div>
        <div class="step-resumo__field">
          <span class="step-resumo__field-label">Funcionamento</span>
          <span class="step-resumo__field-value">
            {{ item.funcionamento || "—" }}
          </span>
        </div>
        <div class="step-resumo__field">
          <span class="step-resumo__field-label">Canais</span>
          <span class="step-resumo__field-value">
            <span v-if="canaisAtivos.length > 0">
              {{ canaisAtivos.map((c) => c.label).join(", ") }}
            </span>
            <span v-else class="step-resumo__field-value--muted">Nenhum</span>
          </span>
        </div>
      </div>
    </div>

    <!-- Regras -->
    <div class="step-resumo__section">
      <div class="section-label">Regras</div>
      <div class="step-resumo__grid">
        <div class="step-resumo__field">
          <span class="step-resumo__field-label">Tipo de campanha</span>
          <span class="step-resumo__field-value">
            {{ getValidacaoLabel(item.validacao) }}
          </span>
        </div>
        <div class="step-resumo__field">
          <span class="step-resumo__field-label">Tipo de regra</span>
          <span class="step-resumo__field-value">
            {{ getTipoLabel(item.tipo) }}
          </span>
        </div>
        <div class="step-resumo__field">
          <span class="step-resumo__field-label">Qtde de regras</span>
          <span class="step-resumo__field-value">
            {{ totalRegras }}
          </span>
        </div>
      </div>

      <!-- Toggles resumo -->
      <div class="step-resumo__toggles">
        <div class="step-resumo__toggle" v-if="item.validarTodasRegras">
          Todas as regras precisam ser válidas
        </div>
        <div class="step-resumo__toggle" v-if="item.validarPorRegra">
          Validação por regra ativa
        </div>
        <div class="step-resumo__toggle" v-if="item.consideraQtdeEstoque">
          Considera quantidade de estoque
        </div>
        <div class="step-resumo__toggle" v-if="item.validaSobrePromocao">
          Valida sobre promoção
        </div>
        <div class="step-resumo__toggle" v-if="item.aplicarSobrePromocao">
          Aplica sobre promoção
        </div>
        <div class="step-resumo__toggle" v-if="item.acumulaDesconto">
          Acumula descontos
        </div>
        <div class="step-resumo__toggle" v-if="item.usaNaoCompra">
          Validação de não compra ativa
        </div>
      </div>
    </div>

    <!-- Brindes -->
    <div class="step-resumo__section">
      <div class="section-label">Brindes</div>
      <div v-if="item.brindes.length === 0" class="step-resumo__empty">
        Nenhum brinde configurado
      </div>
      <div v-else class="step-resumo__list">
        <div
          v-for="brinde in item.brindes"
          :key="brinde.id"
          class="step-resumo__list-item"
        >
          <span>{{ brinde.desc }}</span>
          <span class="step-resumo__list-badge">x{{ brinde.qtde }}</span>
        </div>
      </div>
    </div>

    <!-- Restrições -->
    <div class="step-resumo__section">
      <div class="section-label">Restrições</div>
      <div v-if="item.restricoes.length === 0" class="step-resumo__empty">
        Sem restrições
      </div>
      <div v-else class="step-resumo__list">
        <div
          v-for="(restricao, idx) in item.restricoes"
          :key="idx"
          class="step-resumo__list-item"
        >
          <span class="step-resumo__list-badge">
            {{ getRestricaoLabel(restricao.tipo) }}
          </span>
          <span>{{ restricao.chave }}</span>
        </div>
      </div>
    </div>

    <!-- Checklist de Validação -->
    <div class="step-resumo__section" v-if="checklist.length > 0">
      <div class="section-label section-label--warning">
        Pendências para resolver
      </div>
      <ul class="step-resumo__checklist">
        <li
          v-for="(pendencia, idx) in checklist"
          :key="idx"
          class="step-resumo__checklist-item"
        >
          <CIcon name="cil-warning" size="sm" class="mr-1" />
          {{ pendencia }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {
  getValidacaoLabel,
  getTipoLabel,
  getCanaisAtivos,
  getRestricaoLabel,
} from "../helpers/campanhaLabels";

export default {
  name: "StepResumo",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    canaisAtivos() {
      return getCanaisAtivos(this.item);
    },
    totalRegras() {
      if (this.item.tipo === "MIX") {
        return this.item.mixProdutos.length;
      }
      return this.item.dimensoes.length;
    },
    checklist() {
      const pendencias = [];
      if (!this.item.descricao) pendencias.push("Descrição não preenchida");
      if (!this.item.dataInicio) pendencias.push("Data de início não definida");
      if (!this.item.dataFim) pendencias.push("Data de término não definida");
      if (!this.item.funcionamento)
        pendencias.push("Funcionamento não descrito");
      if (!this.item.validacao)
        pendencias.push("Tipo de campanha não selecionado");
      if (!this.item.tipo) pendencias.push("Tipo de regra não selecionado");
      if (this.canaisAtivos.length === 0)
        pendencias.push("Nenhum canal selecionado");
      if (
        (this.item.tipo === "SEGMENTACAO" || this.item.tipo === "PERSONALIZADO") &&
        this.item.dimensoes.length === 0
      ) {
        pendencias.push("Nenhuma regra de segmento adicionada");
      }
      if (this.item.tipo === "MIX" && this.item.mixProdutos.length === 0) {
        pendencias.push("Nenhum produto adicionado ao mix");
      }
      return pendencias;
    },
  },
  methods: {
    getValidacaoLabel,
    getTipoLabel,
    getRestricaoLabel,
  },
};
</script>

<style scoped>
.step-resumo__section {
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.step-resumo__section:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.section-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #888;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}

.section-label--warning {
  color: #f37b1d;
}

.step-resumo__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.step-resumo__field {
  display: flex;
  flex-direction: column;
}

.step-resumo__field-label {
  font-size: 11px;
  color: #999;
  margin-bottom: 2px;
}

.step-resumo__field-value {
  font-size: 13px;
  color: #333;
}

.step-resumo__field-value--muted {
  color: #aaa;
  font-style: italic;
}

.step-resumo__toggles {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.step-resumo__toggle {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  background-color: #edf8f9;
  color: #2298a3;
  border: 1px solid #c5e6e9;
}

.step-resumo__empty {
  font-size: 13px;
  color: #aaa;
  font-style: italic;
}

.step-resumo__list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.step-resumo__list-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #333;
  padding: 4px 0;
}

.step-resumo__list-badge {
  display: inline-block;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  background-color: #f2f2f8;
  color: #3a3e81;
}

.step-resumo__checklist {
  list-style: none;
  padding: 0;
  margin: 0;
}

.step-resumo__checklist-item {
  font-size: 13px;
  color: #d9534f;
  padding: 4px 0;
  display: flex;
  align-items: center;
}
</style>
